import state from './moduleDashboardCardChartsManagementState.js'
import mutations from './moduleDashboardCardChartsManagementMutations.js'
import actions from './moduleDashboardCardChartsManagementActions.js'
import getters from './moduleDashboardCardChartsManagementGetters.js'

export default {
  isRegistered: false,
  namespaced: true,
  state,
  mutations,
  actions,
  getters

}

